// extracted by mini-css-extract-plugin
export default {"Title":"Title_Title__7Y4Sj"};